import styled from 'styled-components';

export const ExpandedItem = styled.td`
  transition: all 200ms ease-in;
  background-color: ${props =>
    (props.even
      ? `${props.theme.evenTableRow} ${props.overwriteGlobalCSS ? '!important' : ''}`
      : `${props.theme.formBackground} ${props.overwriteGlobalCSS ? '!important' : ''}`)};
`;
